import React from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';

import './index.scss';

const Colors = {
    Blue: 'blue',
    Teal: 'teal',
    Yellow: 'yellow',
    Black: 'black'
};

const CreatorDashboardButton = ({color = Colors.Blue, children, ...props}) => (
    <button className={`creatordashboard-button__${color}`} {...props}>
        {children}
    </button>
);

CreatorDashboardButton.propTypes = {
    color: PropTypes.oneOf(R.values(Colors)),
    children: PropTypes.any,
    onClick: PropTypes.func
};

export default CreatorDashboardButton;



// WEBPACK FOOTER //
// ./creator/components/dashboard_button/index.js